module.exports = __webpack_public_path__ + "static/media/ss_5_jp.e38dec2d.jpg";